export const PATHS = {
  BASE: '/',
  HOME: '/',
}

//Unstructured EE (Retail 2.1)
/*
export const EE = {
  CHECKOUT: 'Checkout',
  PAGE_VIEW: 'Page View',
  PRODUCT_VIEW: 'Product View',
  ADD_TO_CART: 'Add to Cart',
  ORDER_TRACKING: 'orderTracking',
  RATE_CALL: 'rateCall',
  OFFER_ACCEPTED: 'offer.accepted',
  OFFER_DECLINED: 'offer.declined',
  POI_ENTRY: 'geofencing.entry',
  POI_EXIT: 'geofencing.exit',
}

*/

//Structured EE
export const EE = {
  CHECKOUT: 'commerce.purchases',
  PAGE_VIEW: 'web.webpagedetails.pageViews',
  PRODUCT_VIEW: 'commerce.productViews',
  ADD_TO_CART: 'commerce.productListAdds',
  ORDER_TRACKING: 'orderTracking',
  RATE_CALL: 'rateCall',
  OFFER_ACCEPTED: 'offer.accepted',
  OFFER_DECLINED: 'offer.declined',
  POI_ENTRY: 'geofencing.entry',
  POI_EXIT: 'geofencing.exit',
  REGISTER_ACCOUNT: 'account.registration',
  BOT_INTERACTION: 'Bot.interaction',
}

export const CHANNELS = {
  AR: 'ar',
  CALL_CENTER: 'call-center',
  CHATBOT: 'chatbot',
  CRM: 'crm',
  CX: 'cx',
  IOT: 'iot',
  MOBILE: 'mobile',
  STORE: 'store',
  WEB: 'web',
}

export const CHANNEL = '$tenantId.interactionDetails.core.channel'
